import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordComponent } from './password.component';
import { PasswordRoutingModule } from './password-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {PasswordModule} from "../../component/ing/password/password";
import {TableModule} from "../../component/ing/table/table";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	PasswordRoutingModule,
	CatalogueModule,
	DemoModule,
	CodeModule,
	PasswordModule,
	TableModule
  ],
  declarations: [PasswordComponent]
})
export class PasswordDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/password/passwordDemo.module.ts